var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flexbox } from '../../layout';
import { Text, StyledLink, HTMLText } from '../../typography';
import { Button } from '../../forms';
import { CodeBox, CodeText, MessageBox } from './style';
var errorMessages = {
    400: {
        goHomeButton: true,
        title: 'Bad Request',
        message: 'Double check the URL link, or keep exploring other content.'
    },
    403: {
        goHomeLink: true,
        title: 'Not Authorized',
        message: "You don't have permission to access this page. Check that you are logged in with the correct email for this Event, or contact <a href=\"https://support.morressier.com/en\" target=\"_black\">Customer Support</a> for assistance."
    },
    404: {
        goHomeButton: true,
        title: 'Page Not Found',
        message: "We couldn't find the page you're looking for. Keep exploring to find more content."
    },
    500: {
        goHomeLink: true,
        reloadButton: true,
        title: 'System Failure',
        message: "There's been an internal error, but we're working to fix it. Please try again in a moment."
    }
};
var ErrorPageMessage = function (_a) {
    var error = _a.error, homeURL = _a.homeURL, onReloadClick = _a.onReloadClick, _b = _a.renderMessage, renderMessage = _b === void 0 ? function (message) { return (_jsx(HTMLText, __assign({ additionalTags: ['br', 'p', 'a'], allowedAttributes: { href: '', target: '' } }, { children: message }))); } : _b;
    var errorFormatter = error.code &&
        errorMessages[Number(error.code) >= 500
            ? 500
            : Number(error.code)];
    return (_jsxs(Flexbox, __assign({ justifyContent: "center", alignItems: "stretch", style: { maxWidth: '568px' } }, { children: [_jsx(CodeBox, { children: _jsx(CodeText, { children: (error === null || error === void 0 ? void 0 : error.code) || 'Error' }) }), _jsxs(MessageBox, { children: [_jsx(Text, __assign({ size: "h4_new", fontWeight: "bold", color: "secondaryBrand" }, { children: errorFormatter === null || errorFormatter === void 0 ? void 0 : errorFormatter.title })), renderMessage((errorFormatter === null || errorFormatter === void 0 ? void 0 : errorFormatter.message) ||
                        (error === null || error === void 0 ? void 0 : error.message) ||
                        'An error occured while delivering this page.'), _jsxs("div", { children: [(errorFormatter === null || errorFormatter === void 0 ? void 0 : errorFormatter.reloadButton) && (_jsx(Button, __assign({ onClick: onReloadClick, color: "primary" }, { children: "Reload" }))), (errorFormatter === null || errorFormatter === void 0 ? void 0 : errorFormatter.goHomeButton) && (_jsx(Button, __assign({ as: "a", href: homeURL, style: { marginTop: '0.5rem', marginBottom: '0.5rem' } }, { children: "Go Home" }))), (errorFormatter === null || errorFormatter === void 0 ? void 0 : errorFormatter.goHomeLink) && (_jsxs(Text, __assign({ style: { paddingTop: '0.5rem', lineHeight: '1.5rem' } }, { children: ["Or", ' ', _jsx(StyledLink, __assign({ as: "a", href: homeURL, color: "secondaryBrand", style: { fontSize: '1rem' } }, { children: "go back to Home." }))] })))] })] })] })));
};
export default ErrorPageMessage;
//# sourceMappingURL=index.js.map